import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Button, Row, Col, Input } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import { handleChange, formatMessageNew } from '../../utils/common'
// import TagComp from './components/tag'
import TagComp from './components/ReadTag'
import { getCartonList, nddcBindForPhone } from '../../services/PFTag/tag'
import { reset } from '../../services/tag/tag'
import { modalError, modalSuccess, modalWarning, destroyModal } from '../../utils/modalUtils'
import _ from 'lodash'
import './PhoneLayout.less'

// const BTN_WIDTH_60 = 60
const COL_SPAN_24 = 24

let macErrorModal = null
let errorModal = null
let successModal = null

let displayedModalNum = 0
// let gSelectIndex = 0 //当前选中行的index
// let skuTagListCount = 0 //产品的数量
let gRightKeyFlag = false
let gSkuTagObj = {
  carton: '',
  orderNumber: '',
  pendingTagList: []
}
let isTagAllStatus = false
const colStyle = { display: 'flex', flexDirection: 'column', textAlign: 'left', marginBottom: '10px', fontSize: '14px' }
const valueStyle = { fontWeight: 'bold' }

const PFTagPage = props => {
  const [cartonValue, setCartonValue] = useState('')
  const [skuTagList, setSkuTagList] = useState([])
  const [skuUpcList, setSkuUpcList] = useState([])
  const [existNfcList, setExistNfcList] = useState([])
  const [orderNumber, setOrderNumber] = useState('')
  const [isShowUI, setIsShowUI] = useState(true)
  const upcNfcInputRef = useRef(null)
  const cartonInputRef = useRef(null)
  const [gIsTagAll, setGIsTagAll] = useState(false)

  const macState = useSelector(state => state.commonStore.mac)
  const deviceCode = useSelector(state => state.commonStore.deviceCode)
  const rfPath = useSelector(state => state.commonStore.rfPath)
  const [cartonInputReadOnly, setCartonInputReadOnly] = useState(false)
  const [rightKeyFlag, setRightKeyFlag] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)

  const queryHeader = {
    isRF: true,
    mac: macState,
    deviceCode
  }

  // 初始化页面
  useEffect(() => {
    console.log('PFTagPage初始化')
    setTimeout(() => {
      cartonInputRef.current.focus({ cursor: 'all' })
    }, 100)
    window.addEventListener('keydown', onKeyDownBtn) // 添加全局监听键盘事件
    return () => {
      window.removeEventListener('keydown', onKeyDownBtn) // 销毁
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 清除carton 清空数据
  useEffect(() => {
    if (cartonValue.length === 0) resetBtnClick()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartonValue])

  // 按钮事件
  useEffect(() => {
    clearItemBtn(selectedIndex)
    gRightKeyFlag = rightKeyFlag
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rightKeyFlag])

  // 全局监听键盘事件
  const onKeyDownBtn = e => {
    console.log('e.keyCode', e.keyCode)

    switch (e.keyCode) {
      case 112:
        // F1 submit
        console.log('isTagAllStatus', isTagAllStatus)
        if (isTagAllStatus && displayedModalNum === 0) {
          submitClick()
        }
        break
      case 113:
        // F2 reset
        resetBtnClick()
        break
      case 115:
        // F4 clear
        setRightKeyFlag(!gRightKeyFlag)
        break
      case 13:
        // 回车键
        if (macErrorModal) hideMacErrorModal()
        if (errorModal) hideErrorModal()
        if (successModal) hideSuccessModal()
        break
      default:
        break
    }
  }

  const updateIsTagAllStatus = status => {
    setGIsTagAll(status)
    isTagAllStatus = status
  }

  // 显示成功弹窗
  const showSuccessModal = () => {
    if (displayedModalNum > 0) return
    displayedModalNum = 1
    successModal = modalSuccess(
      {
        content: formatMessageNew('languageObj.pftag.tagSuccess')
      },
      () => {
        hideSuccessModal()
      }
    )
  }

  // 关闭成功弹窗
  const hideSuccessModal = () => {
    displayedModalNum = 0
    successModal && destroyModal(successModal)
    successModal = null
  }

  // 显示 Mac 报错 弹窗
  const showMacErrorModal = () => {
    if (displayedModalNum !== 0) return
    displayedModalNum = 1
    console.log('macAddress err-PFtag')
    macErrorModal = modalWarning(
      {
        content: formatMessageNew('languageObj.nsptagLocale.rfMacError')
      },
      hideMacErrorModal
    )
  }

  // 关闭 Mac 报错 弹窗
  const hideMacErrorModal = () => {
    displayedModalNum = 0
    macErrorModal && destroyModal(macErrorModal)
    macErrorModal = null
  }

  // 显示 NFC绑定 错误弹窗
  const showErrorModal = content => {
    if (displayedModalNum !== 0) return
    upcNfcInputRef && upcNfcInputRef.current && upcNfcInputRef.current.clearInterval()
    displayedModalNum = 1
    errorModal = modalError(
      {
        content
      },
      hideErrorModal
    )
  }

  // 关闭 NFC绑定 错误弹窗
  const hideErrorModal = () => {
    displayedModalNum = 0
    errorModal && destroyModal(errorModal)
    errorModal = null
    upcNfcInputRef && upcNfcInputRef.current && upcNfcInputRef.current.clearInputs()
    upcNfcInputRef && upcNfcInputRef.current && upcNfcInputRef.current.openInterval()
  }

  // 输入箱号回车事件
  const onCartonInputKeyDown = e => {
    if (e.keyCode !== 13) return
    getList()
  }

  // 获取产品列表
  const getList = () => {
    cartonInputRef.current.blur()
    if (cartonValue.length === 0) return
    const params = {
      carton: cartonValue
    }
    getCartonList(params, queryHeader)
      .then(res => {
        console.log(res)
        if (res.errorCode === '200') {
          const taglist = []
          const upclist = []
          for (const item of res.resultData.pendingTagList) {
            const requiredTagTypeArr = item.requiredTagType.split(',')
            const requiredTagTypeDescArr = item.requiredTagTypeDesc.split(',')
            const requiredTagTypeList = requiredTagTypeArr.map((type, index) => {
              return `${type} - ${requiredTagTypeDescArr[index]}`
            })
            taglist.push({
              ...item,
              requiredTagTypeList,
              isChecked: false
            })
            if (upclist.indexOf(item.upc) === -1) {
              upclist.push(item.upc)
            }
          }
          setOrderNumber(res.resultData.orderNumber)
          setSkuTagList(taglist)
          setSkuUpcList(upclist)
          setExistNfcList([])
          setIsShowUI(true)
          // skuTagListCount = taglist.length
          upcNfcInputRef && upcNfcInputRef.current.clearInputs()
        }
      })
      .catch(error => {
        console.log(error)
        let str = ''
        switch (error.errorCode) {
          case '601':
            str = 'languageObj.pftag.cartonDoesNotExist'
            break
          case '602':
            str = 'languageObj.pftag.cartonDoesNotIncludeNFCSKU'
            break
          case '603':
            str = 'languageObj.pftag.cartonAlreadyTag'
            break
          case '433':
            str = 'languageObj.pftag.errorcode_433'
            break
          case '604':
            str = 'languageObj.pftag.errorcode_604'
            break
          default:
            str = 'languageObj.nsptagLocale.requestError'
            break
        }
        showErrorModal(formatMessageNew(str))
        resetBtnClick()
      })
  }

  // 重置NFC读取 接口
  const resetUidFun = () => {
    reset()
      .then(res => {
        console.log(res)
      })
      .catch(error => {
        console.log(error)
      })
  }

  // 箱号input聚焦事件
  const onCartonInputFocusFun = e => {
    setCartonInputReadOnly(true)
    setTimeout(() => {
      setCartonInputReadOnly(false)
    }, 100)
  }

  const scrollToUpc = upcValue => {
    const dom = document.querySelector(`#upc_${upcValue}`)
    dom && dom.scrollIntoView(true)
    const index = _.findIndex(skuTagList, { upc: upcValue })
    setSelectedIndex(index)
  }

  // 将UPC和NFC存到到tag信息里
  const tagItem = (upcValue, nfcValue, actualTagType) => {
    //产品在箱号列表中不存在
    if (upcValue && skuUpcList.indexOf(upcValue) === -1) {
      showErrorModal(formatMessageNew('languageObj.pftag.skuDoesNotExist'))
      return
    }

    //NFC已被绑定
    if (nfcValue && existNfcList.indexOf(nfcValue) !== -1) {
      showErrorModal(formatMessageNew('languageObj.pftag.alreadyTag'))
      return
    }
    if (upcValue && nfcValue && actualTagType) {
      const tempList = _.cloneDeep(skuTagList)
      let firstMatchIndex = null
      let firstMatchItem = null
      for (let i = 0; i < skuTagList.length; i++) {
        const e = skuTagList[i]
        // upc可能是重复的, 如果已经绑定了isChecked=true
        if (e.upc === upcValue && !e.isChecked) {
          // 标签不匹配类型
          let requiredTagTypeLs = (e.requiredTagType && e.requiredTagType.split(',')) || []
          if (actualTagType && actualTagType !== '0000' && requiredTagTypeLs.indexOf(actualTagType) === -1) {
            const content = `${e.productCode}-${e.productSize} ${formatMessageNew(
              'languageObj.nsptagLocale.nddcTagTypeNotMatch'
            )} '${e.requiredTagType}'`
            showErrorModal(content)
          } else {
            e.nfcUid = nfcValue
            e.isChecked = true
            e.actualTagType = actualTagType
            firstMatchIndex = i
            firstMatchItem = e
          }
          break
        }
      }

      if (firstMatchIndex !== null && firstMatchItem !== null) {
        tempList[firstMatchIndex] = firstMatchItem
        setSkuTagList(tempList)
        setExistNfcList([...existNfcList, nfcValue])
      }
      upcNfcInputRef && upcNfcInputRef.current.clearInputs()
      checkTagStatus(tempList)
    }
  }

  // 检查是否全部绑定
  const checkTagStatus = list => {
    const noTaglist = list.filter(item => item.isChecked === false)
    if (noTaglist.length === 0) {
      //全部绑定了
      updateIsTagAllStatus(true)
      upcNfcInputRef && upcNfcInputRef.current.inputBlur()
      gSkuTagObj = {
        carton: cartonValue,
        orderNumber: orderNumber,
        pendingTagList: list
      }
      // 滚动到顶部
      const dom = document.querySelector(`#nddc-tag-wrapper`)
      dom && dom.scrollIntoView(true)
    }
  }

  // 清除按钮 事件
  const clearItemBtn = index => {
    console.log(index)
    console.log('清除事件')
    const tempList = []
    for (let i = 0; i < skuTagList.length; i++) {
      const e = skuTagList[i]
      if (index === i) {
        clearNfcList(e.nfcUid)
        e.nfcUid = ''
        e.actualTagType = ''
        e.isChecked = false
      }
      tempList.push({
        ...e
      })
    }
    setSkuTagList(tempList)
    updateIsTagAllStatus(false)
    upcNfcInputRef && upcNfcInputRef.current.clearInputs()
  }

  // 已绑定列表中 清除该记录的NFC信息
  const clearNfcList = nfcValue => {
    const tempList = existNfcList.filter(item => {
      return item !== nfcValue
    })
    setExistNfcList(tempList)
  }

  // 重置按钮 事件
  const resetBtnClick = () => {
    resetUidFun()
    setCartonValue('')
    setOrderNumber('')
    setSkuTagList([])
    setExistNfcList([])
    setIsShowUI(false)
    updateIsTagAllStatus(false)
    setSelectedIndex(0)
    gRightKeyFlag = false
    gSkuTagObj = {
      carton: '',
      orderNumber: '',
      pendingTagList: []
    }
    cartonInputRef.current.focus({ cursor: 'all' })
  }

  // 提交按钮 事件
  const submitClick = () => {
    upcNfcInputRef && upcNfcInputRef.current.clearInterval()
    const list = gSkuTagObj.pendingTagList.filter(item => {
      return item.isChecked === false
    })
    // 报错 - 未绑定所有产品
    if (list.length > 0) {
      showErrorModal(formatMessageNew('languageObj.pftag.taggingAll'))
      return
    }
    // ???
    if (
      gSkuTagObj.carton.length === 0 ||
      gSkuTagObj.orderNumber.length === 0 ||
      gSkuTagObj.pendingTagList.length === 0
    ) {
      return
    }
    const pendingTagList = gSkuTagObj.pendingTagList.map(item => {
      const keys = Object.keys(item)
      const obj = {}
      keys.forEach(key => {
        if (!['isChecked', 'requiredTagTypeList'].includes(key)) {
          obj[key] = item[key]
        }
      })
      return obj
    })
    gSkuTagObj.displayTagPic = true
    gSkuTagObj.rfPath = rfPath
    const params = {
      ...gSkuTagObj
    }
    params.pendingTagList = pendingTagList
    nddcBindForPhone(params, queryHeader)
      .then(res => {
        if (res.errorCode === '200') {
          updateIsTagAllStatus(false)
          showSuccessModal()
          resetBtnClick()
        }
      })
      .catch(error => {
        let msg = ''
        switch (error.errorCode) {
          case '417':
            msg = formatMessageNew('languageObj.pftag.errorcode_417') + ': ' + error.resultData.join('、')
            break
          case '419':
            msg = formatMessageNew('languageObj.pftag.errorcode_419')
            break
          case '903':
            msg = formatMessageNew('languageObj.pftag.errorcode_903')
            break
          case '439':
            msg = formatMessageNew('languageObj.pftag.errorcode_439')
            break
          case '433':
            msg = formatMessageNew('languageObj.pftag.errorcode_433')
            break
          case '416':
            msg = formatMessageNew('languageObj.pftag.errorcode_416')
            break
          case '442':
            msg = formatMessageNew('languageObj.nsptagLocale.NFCUIDDisabled')
            break
          case '4171':
            msg = formatMessageNew('languageObj.pftag.errorcode_4171')
            break
          case '603':
            msg = formatMessageNew('languageObj.pftag.cartonAlreadyTag')
            break
          case '901':
            msg = formatMessageNew('languageObj.pftag.errorcode_901')
            break
          case '902':
            msg = formatMessageNew('languageObj.pftag.errorcode_902')
            break
          case '604':
            msg = formatMessageNew('languageObj.pftag.errorcode_604')
            break
          case '905':
            msg = `${error.resultData.productCode} ${formatMessageNew(
              'languageObj.nsptagLocale.nddcTagTypeNotMatch'
            )} '${error.resultData.requiredTagType}'`
            break
          default:
            msg = formatMessageNew('languageObj.httpLocale.requestError')
            break
        }
        showErrorModal(msg)
      })
  }

  // 检查是否启用中间件
  const showMacError = () => {
    if (!macState) {
      showMacErrorModal()
      return true
    }
    return false
  }

  // NFC接口报错
  const confirmDialog = () => {
    showMacErrorModal()
  }

  return (
    <div className="nddc-tag-wrapper" id="nddc-tag-wrapper">
      <div className="test">
        <Row className="mt5">
          <Col style={{ display: 'flex', alignItems: 'center' }} span={7} className="fs-15">
            <span style={{ textAlign: 'right', marginRight: 5 }} id="carton">
              {formatMessageNew('languageObj.pftag.carton')}
            </span>
          </Col>
          <Col span={17}>
            <Input
              className="fs-15"
              style={{ flex: 1 }}
              value={cartonValue}
              ref={cartonInputRef}
              onChange={e => handleChange(e, { setState: setCartonValue })}
              placeholder={formatMessageNew('languageObj.pftag.pleaseScan')}
              allowClear
              readOnly={cartonInputReadOnly}
              onKeyUp={e => onCartonInputKeyDown(e)}
              // onBlur={e => onBlurFun(e)}
              onFocus={e => onCartonInputFocusFun(e)}
            />
          </Col>
        </Row>
        {isShowUI && (
          <div>
            <Row className="mt15">
              <Col span={COL_SPAN_24}>
                <TagComp
                  ref={upcNfcInputRef}
                  tagItem={tagItem}
                  scrollToUpc={scrollToUpc}
                  confirmDialog={confirmDialog}
                  showMacError={showMacError}
                />
              </Col>
            </Row>
            <Row className="mt15">
              <Col style={{ display: 'flex', alignItems: 'center' }} span={8} className="fs-15">
                <span style={{ textAlign: 'right', marginRight: 5 }}>
                  {formatMessageNew('languageObj.pftag.salesOrder')}
                </span>
              </Col>
              <Col span={16} className="fs-15">
                {orderNumber}
              </Col>
            </Row>

            <Row className="mt15">
              <Col className="mt15" style={{ display: 'flex' }} span={COL_SPAN_24}>
                <Button
                  className="fs-15 phone-btn"
                  type="primary"
                  onClick={() => {
                    resetBtnClick()
                  }}
                  style={{ height: 'auto' }}
                >
                  {`${formatMessageNew('languageObj.nsptagLocale.reset')} (F2)`}
                </Button>
                <Button
                  className="fs-15 phone-btn"
                  type="primary"
                  disabled={!(gIsTagAll && displayedModalNum === 0)}
                  onClick={() => {
                    if (gIsTagAll && displayedModalNum === 0) {
                      submitClick()
                    }
                  }}
                  style={{ height: 'auto', marginLeft: '20px' }}
                >
                  {`${formatMessageNew('languageObj.pftag.submit')} (F1)`}
                </Button>
              </Col>
            </Row>

            <div
              style={{
                marginTop: '30px',
                maxHeight: '45%',
                overflowY: 'auto'
              }}
              id="scrollDiv"
            >
              {skuTagList.map((item, index) => {
                return (
                  <div
                    id={`upc_${item.upc}`}
                    align={'middle'}
                    className="detail-list"
                    key={index}
                    style={{
                      backgroundColor: selectedIndex === index ? '#f1f1f1' : 'white'
                    }}
                    onClick={() => {
                      setSelectedIndex(index)
                    }}
                  >
                    <Row>
                      <Col span={12} style={colStyle}>
                        <span>{formatMessageNew('languageObj.pftag.productCode')}</span>
                        <span style={valueStyle}>{`${item.productCode}-${item.productSize}`}</span>
                      </Col>
                      <Col span={12} style={colStyle}>
                        <span>{formatMessageNew('languageObj.pftag.requiredTagType')}</span>
                        <span style={valueStyle}>
                          {item.requiredTagTypeList.map((type, index) => (
                            // ff6304
                            <p key={index} style={{ color: 'rgb(24, 144, 255)', margin: 0 }}>
                              {type}
                            </p>
                          ))}
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} style={colStyle}>
                        <span>{formatMessageNew('languageObj.pftag.upc')}</span>
                        <span style={valueStyle}>{item.isChecked ? item.upc : ''}</span>
                      </Col>
                      <Col span={12} style={colStyle}>
                        <span>{formatMessageNew('languageObj.pftag.nfcUid')}</span>
                        <span style={valueStyle}>{item.nfcUid}</span>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={12} style={colStyle}>
                        <span>{formatMessageNew('languageObj.pftag.actualTagType')}</span>
                        <span style={valueStyle}>{item.actualTagType}</span>
                      </Col>
                      <Col span={12} style={colStyle}>
                        <span>{formatMessageNew('languageObj.pftag.tagStatus')}</span>
                        <span style={valueStyle}>
                          {item.isChecked ? (
                            <CheckOutlined style={{ color: 'rgb(22, 119, 255)', fontSize: '30px' }} />
                          ) : null}
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24} style={{ textAlign: 'right' }}>
                        <Button
                          type="primary"
                          disabled={!item.isChecked}
                          className="phone-btn"
                          onClick={() => {
                            clearItemBtn(index)
                          }}
                          // style={{ fontSize: '12px', height: 'auto' }}
                        >
                          {`${formatMessageNew('languageObj.pftag.clear')} ${selectedIndex === index ? '(F4)' : ''}`}
                        </Button>
                      </Col>
                    </Row>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PFTagPage
